<template>
    <div class="stats-table">
        <v-data-table
            :headers="headers"
            :items="teams || []"
            sort-by="points"
            sort-desc
            class="cl-table"
            hide-default-footer
            :mobile-breakpoint="0"
            :items-per-page="-1"
            dark
            no-data-text="Δεν υπάρχουν ακόμη στατιστικά"
            @click:row="team => team.id && $router.push({ name: 'Team', params: { id: team.id } })"
        >
            <template v-slot:item.name="{ item }">
                <span class="stats-table__who">
                    <span v-if="item.logo" class="cl-logo stats-table__logo"><img :src="`${assetsUrl}/${item.logo}`" alt=""></span>
                    {{ item.name }}
                </span>
            </template>
            <template v-slot:item.two_points_percentage="{ item }">
                <span class="stats-table__pct">{{ item.two_points_percentage }}%</span>
                <span v-if="option" class="stats-table__ratio">{{ item.cum.twoPointsMade }}/{{ item.cum.twoPointAttempts }}</span>
            </template>
            <template v-slot:item.three_points_percentage="{ item }">
                <span class="stats-table__pct">{{ item.three_points_percentage }}%</span>
                <span v-if="option" class="stats-table__ratio">{{ item.cum.threePointsMade }}/{{ item.cum.threePointAttempts }}</span>
            </template>
            <template v-slot:item.free_throw_percentage="{ item }">
                <span class="stats-table__pct">{{ item.free_throw_percentage }}%</span>
                <span v-if="option" class="stats-table__ratio">{{ item.cum.freeThrowsMade }}/{{ item.cum.freeThrowAttempts }}</span>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    export default {
        props: {
            teams: {
                type: Array,
                default: null
            },
            option: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com',
                headers: [
                    { text: 'Team', value: 'name', align: 'start' },
                    { text: 'GP', value: 'gp', align: 'center' },
                    { text: 'Pts', value: 'points', align: 'center' },
                    { text: '2P%', value: 'two_points_percentage', align: 'center' },
                    { text: '3P%', value: 'three_points_percentage', align: 'center' },
                    { text: 'FT%', value: 'free_throw_percentage', align: 'center' },
                    { text: 'OR', value: 'offensiveRebounds', align: 'center' },
                    { text: 'DR', value: 'defensiveRebounds', align: 'center' },
                    { text: 'TR', value: 'rebounds', align: 'center' },
                    { text: 'AST', value: 'assists', align: 'center' },
                    { text: 'STL', value: 'steals', align: 'center' },
                    { text: 'TO', value: 'turnovers', align: 'center' },
                    { text: 'BLK', value: 'blockedShots', align: 'center' },
                    { text: 'FC', value: 'fouls', align: 'center' }
                ]
            }
        },
        watch: {
            option: {
                handler() {
                    this.prepareData()
                }
            },
            teams: {
                handler() {
                    this.prepareData()
                }
            }
        },
        created() {
            if (this.generic) {
                this.headers = [{ text: 'Team', value: 'team' }, ...this.headers]
            }
            this.prepareData()
        },
        methods: {
            prepareData() {
                this.teams.forEach(team => {
                    team.points = this.option ? team.cum.points : team.avg.points.toFixed(1)
                    team.gp = team.stats.length
                    team.two_points_percentage = this.option ? (team.cum.twoPointsMade / (team.cum.twoPointAttempts ? team.cum.twoPointAttempts : 1) * 100).toFixed(1) : (team.avg.twoPointsMade / (team.avg.twoPointAttempts ? team.avg.twoPointAttempts : 1) * 100).toFixed(1)
                    team.free_throw_percentage = this.option ? (team.cum.freeThrowsMade / (team.cum.freeThrowAttempts ? team.cum.freeThrowAttempts : 1) * 100).toFixed(1) : (team.avg.freeThrowsMade / (team.avg.freeThrowAttempts ? team.avg.freeThrowAttempts : 1) * 100).toFixed(1)
                    team.three_points_percentage = this.option ? (team.cum.threePointsMade / (team.cum.threePointAttempts ? team.cum.threePointAttempts : 1) * 100).toFixed(1) : (team.avg.threePointsMade / (team.avg.threePointAttempts ? team.avg.threePointAttempts : 1) * 100).toFixed(1)
                    team.offensiveRebounds = this.option ? team.cum.offensiveRebounds : team.avg.offensiveRebounds.toFixed(1)
                    team.defensiveRebounds = this.option ? team.cum.defensiveRebounds : team.avg.defensiveRebounds.toFixed(1)
                    team.rebounds = this.option ? team.cum.rebounds : team.avg.rebounds.toFixed(1)
                    team.assists = this.option ? team.cum.assists : team.avg.assists.toFixed(1)
                    team.steals = this.option ? team.cum.steals : team.avg.steals.toFixed(1)
                    team.turnovers = this.option ? team.cum.turnovers : team.avg.turnovers.toFixed(1)
                    team.blockedShots = this.option ? team.cum.blockedShots : team.avg.blockedShots.toFixed(1)
                    // every foul: personal, technical and unsportsmanlike
                    team.fouls = this.option ? team.cum.fouls : team.avg.fouls.toFixed(1)
                })
            }
        }
    }
</script>

<style scoped>
.stats-table__bar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
}

.stats-table__search {
    max-width: 320px;
}

.stats-table__count {
    font-family: Roboto, Arial, sans-serif;
    font-size: 0.8rem;
    color: rgba(35, 35, 35, 0.55);
}

.stats-table ::v-deep td {
    white-space: nowrap;
}

/* the sticky first column of the site's tables, on the charcoal of this one */
.stats-table ::v-deep table > tbody > tr > td:nth-child(1),
.stats-table ::v-deep table > thead > tr > th:nth-child(1) {
    position: sticky !important;
    left: 0;
    z-index: 2;
    background: #232323 !important;
    box-shadow: 1px 0 0 rgba(255, 255, 255, 0.08);
}

.stats-table ::v-deep table > thead > tr > th:nth-child(1) {
    z-index: 3;
    background: #1b1b1b !important;
}

.stats-table ::v-deep tbody tr {
    cursor: pointer;
}

.stats-table__who {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 700;
}

.stats-table__photo {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #2e2e2e;
    object-fit: cover;
    object-position: top;
}

.stats-table__logo {
    width: 30px;
    height: 30px;
}

.stats-table__pct {
    font-weight: 700;
}

.stats-table__ratio {
    display: block;
    margin-left: 0;
    font-size: 0.72rem;
    line-height: 1;
    color: rgba(255, 255, 255, 0.5);
}

.stats-table__eff {
    font-family: 'Squada One', 'Roboto Condensed', Arial, sans-serif;
    font-size: 1.2rem;
    color: #03e5b7;
}

/* compact: every column fits a laptop without scrolling */
.stats-table ::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.stats-table ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    padding: 0 7px !important;
}

.stats-table ::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th:first-child,
.stats-table ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td:first-child {
    padding-left: 14px !important;
}

.stats-table ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    height: 46px !important;
    font-size: 0.85rem !important;
}

.stats-table__names {
    display: flex;
    flex-direction: column;
    min-width: 0;
    line-height: 1.2;
}

.stats-table__name {
    max-width: 210px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.stats-table__sub {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    max-width: 210px;
    margin-top: 2px;
    overflow: hidden;
    font-size: 0.7rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.55);
    text-overflow: ellipsis;
}

.stats-table__mini-logo {
    flex: 0 0 auto;
    width: 16px;
    height: 16px;
    border-radius: 3px;
}

@media (max-width: 700px) {
    .stats-table__name,
    .stats-table__sub {
        max-width: 130px;
    }

    .stats-table__photo {
        display: none;
    }
}
</style>
